import { cachedHttp } from "./httpService";

function getCountries({ enabledOnly = true } = {}) {
  return cachedHttp.get(enabledOnly ? "/countries/?enabled=true" : "/countries/");
}

export default getCountries;
